const styles = (theme) => ({
	containerModal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
	},
	container: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: "16px",
		borderRadius: "22px",
		position: "relative",
		width: "450px",
		padding: {
			xs: "10px",
			sm: "10px",
		},
		background: theme.palette.secondary.darker,
		maxWidth: "80vw",
	},
	Avatar: {
		height: "90px",
		width: "90px",
		border: `solid 4px`,
		borderColor: theme.palette.secondary.darker,
		color: theme.palette.white.main,
		background:
			theme.palette.mode == "dark"
				? theme.palette.colors.gray.dark
				: theme.palette.black.light,
	},
	BoxAvatar: {
		width: "126px",
		height: "126px",
		borderRadius: "50%",
		alignItems: "center",
		justifyContent: "center",
		display: "flex",
		marginLeft: "70px",
		marginBottom: "110px",
	},
	StackFoto: {
		alignItems: "center",
		height: "220px",
		position: "absolute",

		marginRight: "360px",
	},
	boxAreaTituloModalPerfil: {
		position: "relative",
		width: "100%",

		display: "flex",
		alignItems: "flex-end",
		justifyContent: "center",
	},
	boxAreaModalPerfil: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "flex-start",

		padding: "10px",
	},
	boxAreaConteudoModalPerfil: {
		background: theme.palette.background.modalContrast,
		width: "100%",
		minHeight: "388px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "space-between",
		borderRadius: "22px",
		padding: "30px",
		paddingTop: "10px",
	},
	boxAreaButtomModalPerfil: {
		/* background: "pink", */
		width: "100%",
		height: "36px",
		display: "flex",
		alignItems: "flex-start",
		justifyContent: "flex-end",
	},
	containerButtonSalvar: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		mt: 1,
		ml: 1,
		mr: 1,
	},
	TextField: {
		width: "100%",
		borderRadius: "8px",
		bgcolor:
			theme.palette.mode == "dark"
				? theme.palette.secondary.dark
				: theme.palette.secondary.light,
		"& .MuiFilledInput-root": {
			backgroundColor: "transparent",
		},
		"& .Mui-disabled": {
			backgroundColor:
				theme.palette.mode == "dark"
					? theme.palette.secondary.dark
					: theme.palette.secondary.light,
			borderRadius: "8px",
		},
		"& .MuiFilledInput-root:hover": {
			bgcolor:
				theme.palette.mode == "dark"
					? theme.palette.secondary.darker
					: theme.palette.secondary.light,
		},
		"& .MuiInputLabel-filled": {
			color:
				theme.palette.mode == "dark"
					? theme.palette.colors.gray.light
					: theme.palette.secondary.dark,
		},
		"& .MuiFilledInput-input": {
			color:
				theme.palette.mode == "dark"
					? theme.palette.white.main
					: theme.palette.colors.black.dark,
		},
		"& .MuiInputBase-input.Mui-disabled": {
			WebkitTextFillColor:
				theme.palette.mode == "dark"
					? theme.palette.colors.gray.light
					: theme.palette.colors.black.medium,
		},
	},
	selectCliente: {
		width: "100%",
		bgcolor: "red",
	},
	stackCliente: {
		width: "100%",
	},
	divider: {
		width: "100%",
	},
	textBold: {
		fontWeight: "bold",
	},
	boxStatusItem: {
		position: "relative",
		display: "flex",
		alignItems: "flex-end",
		justifyContent: "flex-start",
		gap: "6px",
		mt: "-1px",
	},
	person: {
		color: "primary.main",
		mt: "-3px",
		fontSize: "22px",
	},
	button: {
		borderRadius: "10px",
		height: "40px",
	},
});

export default styles;
